import React from 'react';
import './styles.css';

const Title = ({ title, style }) => (
    <p style={style} className="Title" >{title}</p>
);

export default Title;